import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { AppSpan, AppText, Button, CustomContainer, FlexRow, ScreenContainer, ScreenTitle } from "src/style"
import {ReactComponent as NoUserIcon} from 'src/assets/svg/no-user-icon.svg'
import utility from "src/utils/utility"
import { SearchInput, ServerSideTable, Table } from 'src/component'
import { subsidiariesColumn, subsidiariesData } from 'src/utils/tableLayout'
import { Subsidiary } from 'src/model'
import helpers from 'src/utils/helpers'
import { IoMdAdd } from "react-icons/io";
import { NewSubsidiaryDetails, NewSubsidiaryDocs } from 'src/popup'

const Subsidiaries = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {organization}, setInfoProperty} = useContext(AppInfoContext)
    const [subsidiaryInfo, setSubsidiaryInfo] = useState<any>(null)
    const [subsidiaries, setSubsidiaries] = useState<Array<Subsidiary>|null>(null)
    const [mockTableData, setMockTableData] = useState<any[]>([])
    const [showSendEmail, setShowSendEmail] = useState(false)
    const [formData, setFormData] = useState({
        name: '', website: '', phoneNumber: '', email: '',
        dateOfIncorporation: '', address: '', city: '', state: '',
        country: 'Nigeria', document: ''
    })
    const [view, setView] = useState('')

    useEffect(() => {
        handleFetchSubsidiaries()
    }, []) 

    async function handleFetchSubsidiaries () {
        const response = await API.getOrganizationSubsidiariesStats()
        if (response) {
            setSubsidiaries(response)
            setMockTableData(response)
        }
    }

    function handleDataSearching (e: React.ChangeEvent<HTMLInputElement>) {
        const filteredData = helpers.searchTableData(subsidiaries, e.target.value)
        setMockTableData(filteredData)
    }

    async function handleRowClick (data: Subsidiary, option: string) {
        await setInfoProperty('selectedSubsidiary', data.subsidiary)
        if (option === 'view-customers') navigate('/dashboard/customers')
        else navigate('/dashboard/subsidiaries/subsidiary-details')
    }

    function handleSelectedOption (data: Subsidiary, option: string) {
        if (option.includes('view')) handleRowClick(data, option)
        else setShowSendEmail(true)
    }

    async function handleAddSubsidiary () {
        const data = new FormData();
        data.append('name', formData.name);
        data.append('email', formData.email);
        data.append('document', formData.document);
        data.append('phoneNumber', formData.phoneNumber);
        data.append('website', formData.website);
        data.append('dateOfIncorporation', formData.dateOfIncorporation);
        data.append('address', formData.address);
        data.append('city', formData.city);
        data.append('state', formData.state);
        data.append('country', formData.country);

        const response = await API.addSubsidiary(data)
        if (response) {
            handleFetchSubsidiaries()
        }
    }

    return (
        <>
            <ScreenContainer padding='2.5'>
                <CustomContainer>
                    <ScreenTitle 
                        color='#333333' 
                        textSize='2.4' 
                        fontWeight='700'
                    >
                        Subsidiaries
                    </ScreenTitle>
                    <AppSpan>List of all {organization?.name} subsidiaries</AppSpan>
                </CustomContainer>

                { (subsidiaries && subsidiaries?.length > 0) &&
                    <FlexRow 
                        gap='2' topMargin='4'
                        wrap='wrap'
                        justifyContent='flex-end' 
                    >
                        <SearchInput onChange={handleDataSearching} />
                        <Button 
                            width='23.5' 
                            hoverBgColor='#ffffff' 
                            hoverColor='#5627FF'
                            borderColor='#5627FF'
                            onClick={() => setView('subsidiary-details')}
                        >
                            <IoMdAdd fontSize='1.9rem' style={{marginRight: '1rem'}} />
                            Add New Subsidiary
                        </Button>
                    </FlexRow>
                }
                <CustomContainer 
                    topMargin='4'
                    className='no-user-container'
                >
                    <Table
                        tableColumns={subsidiariesColumn(true, handleSelectedOption)}
                        tableData={mockTableData}
                        //dataFetchMethod={handleFetchSubsidiaries}
                        //totalRows={subsidiaryInfo?.totalResults}
                        //onRowClickMethod={handleRowClick}
                        noDataText={
                            <>
                                <AppText 
                                    textSize="1.6" 
                                    color="#000000" 
                                    fontWeight="700"
                                    align='center'
                                >
                                    No subsidiaries added yet
                                </AppText>
                                <AppSpan textSize="1.6" color="#000000" align='center'>
                                    You have not added any subsidiaries yet. 
                                </AppSpan>
                            </>
                        }
                        noDataCustomIcon={ <NoUserIcon className="icon-component" /> }
                        actionComponent={ 
                            <Button 
                                width='22.4' 
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                                topMargin='3'
                                onClick={() => setView('subsidiary-details')}
                            >
                                Add Subsidiary
                            </Button>
                        }
                    />
                </CustomContainer>
            </ScreenContainer>
            { view === 'subsidiary-details' &&
                <NewSubsidiaryDetails 
                    close={() => setView('')}
                    formData={formData}
                    setFormData={setFormData}
                    next={() => setView('subsidiary-docs')}
                />
            }
            { view === 'subsidiary-docs' &&
                <NewSubsidiaryDocs
                    close={() => setView('')}
                    formData={formData}
                    setFormData={setFormData}
                    back={() => setView('subsidiary-details')}
                    next={handleAddSubsidiary}
                />
            }
        </>
    )
}

export default utility.routeData('subsidiaries', 'Subsidiaries', <Subsidiaries/>)